import {SITE_SUFFIX} from 'tizra'

// This doesn't use router because it doesn't include hostname.
export const useHostnameSuffix = () => SITE_SUFFIX
